import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'waste_sources'

export const dataPointDefinition = {
  retracedId: 'waste_sources',
  name: 'What is the volume generated for all waste streams?',
  meta: {
    isMultipleRow: true,
    columns: [
      {
        key: 1,
        name: 'Waste Category',
        type: 'SELECT',
        id: 'waste_category',
        options: [
          {
            key: 'DISCARDED_TEXTILES',
            text: 'Discarded Textiles',
          },
          {
            key: 'GLASS',
            text: 'Glass',
          },
          {
            key: 'METALS',
            text: 'Metals',
          },
          {
            key: 'ORGANIC_WASTE',
            text: 'Organic Waste',
          },
          {
            key: 'PAINTS_&_SOLVENTS',
            text: 'Paints & solvents',
          },
          {
            key: 'PAPER_&_CARDBOARD',
            text: 'Paper & cardboard',
          },
          {
            key: 'PCBS_&_PCTS',
            text: 'PCBs & PCTs',
          },
          {
            key: 'PLASTICS',
            text: 'Plastics',
          },
          {
            key: 'RUBBER_WASTE',
            text: 'Rubber waste',
          },
          {
            key: 'UNKNOWN',
            text: 'Unknown',
          },
          {
            key: 'WASTE_OILS',
            text: 'Waste oils',
          },
          {
            key: 'WOOD_WASTE',
            text: 'Wood waste',
          },
        ],
      },
      {
        key: 2,
        name: 'Disposal Method',
        type: 'SELECT',
        id: 'disposal_method',
        options: [
          {
            key: 'COMPOSTING_GARBAGE',
            text: 'Composting garbage',
          },
          {
            key: 'INCINERATE,_BURN_OR_DISPOSE_ON-SITE_(UNCERTIFIED)',
            text: 'Incinerate, burn or dispose on-site (uncertified)',
          },
          {
            key: 'MUNICIPAL_GARBAGE_COLLECTION',
            text: 'Municipal garbage collection',
          },
          {
            key: 'ON-SITE_DISPOSAL_(THIRD-PARTY_REVIEWED_OR_AUDITED)',
            text: 'On-site disposal (third-party reviewed or audited)',
          },
          {
            key: 'PRIVATE_THIRD-PART_RESPONSIBLE_DISPOSAL_(CERTIFIED)',
            text: 'Private third-part responsible disposal (certified)',
          },
          {
            key: 'THIRD-PARTY_GARBAGE_COLLECTION_(UNCERTIFIED)',
            text: 'Third-party garbage collection (uncertified)',
          },
          {
            key: 'UNKNOWN',
            text: 'Unknown',
          },
          {
            key: "WASTE_IS_SEPARATED_AND_RECYCLED_OR_REUSED_FOR_ORGANIZATION'S_OWN_PRODUCTION_OR_DONATED/PROVIDED_TO_OTHER_FACILITIES",
            text: "Waste is separated and recycled or reused for organization's own production or donated/provided to other facilities",
          },
        ],
      },
      {
        key: 3,
        name: 'Total Annual Volume',
        type: 'NUMBER_DYNAMIC_UOM',
        id: 'total_annual_volume',
        unitOptions: [
          {
            label: 'kg',
            text: 'kg',
            key: 'KILOGRAM',
          },
          {
            label: 't',
            text: 'metric ton',
            key: 'METRIC_TON',
          },
        ],
      },
      {
        key: 4,
        name: 'Year',
        type: 'SELECT_YEAR',
        id: 'year',
      },
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'RELATIONAL',
  options: [
    {
      wasteCategory: [
        {
          key: 'DISCARDED_TEXTILES',
          text: 'Discarded Textiles',
        },
        {
          key: 'GLASS',
          text: 'Glass',
        },
        {
          key: 'METALS',
          text: 'Metals',
        },
        {
          key: 'ORGANIC_WASTE',
          text: 'Organic Waste',
        },
        {
          key: 'PAINTS_&_SOLVENTS',
          text: 'Paints & solvents',
        },
        {
          key: 'PAPER_&_CARDBOARD',
          text: 'Paper & cardboard',
        },
        {
          key: 'PCBS_&_PCTS',
          text: 'PCBs & PCTs',
        },
        {
          key: 'PLASTICS',
          text: 'Plastics',
        },
        {
          key: 'RUBBER_WASTE',
          text: 'Rubber waste',
        },
        {
          key: 'UNKNOWN',
          text: 'Unknown',
        },
        {
          key: 'WASTE_OILS',
          text: 'Waste oils',
        },
        {
          key: 'WOOD_WASTE',
          text: 'Wood waste',
        },
      ],
    },
    {
      disposalMethod: [
        {
          key: 'COMPOSTING_GARBAGE',
          text: 'Composting garbage',
        },
        {
          key: 'INCINERATE,_BURN_OR_DISPOSE_ON-SITE_(UNCERTIFIED)',
          text: 'Incinerate, burn or dispose on-site (uncertified)',
        },
        {
          key: 'MUNICIPAL_GARBAGE_COLLECTION',
          text: 'Municipal garbage collection',
        },
        {
          key: 'ON-SITE_DISPOSAL_(THIRD-PARTY_REVIEWED_OR_AUDITED)',
          text: 'On-site disposal (third-party reviewed or audited)',
        },
        {
          key: 'PRIVATE_THIRD-PART_RESPONSIBLE_DISPOSAL_(CERTIFIED)',
          text: 'Private third-part responsible disposal (certified)',
        },
        {
          key: 'THIRD-PARTY_GARBAGE_COLLECTION_(UNCERTIFIED)',
          text: 'Third-party garbage collection (uncertified)',
        },
        {
          key: 'UNKNOWN',
          text: 'Unknown',
        },
        {
          key: "WASTE_IS_SEPARATED_AND_RECYCLED_OR_REUSED_FOR_ORGANIZATION'S_OWN_PRODUCTION_OR_DONATED/PROVIDED_TO_OTHER_FACILITIES",
          text: "Waste is separated and recycled or reused for organization's own production or donated/provided to other facilities",
        },
      ],
    },
    {
      totalAnnualVolume: [
        {
          label: 'kg',
          text: 'kg',
          key: 'KILOGRAM',
        },
        {
          label: 't',
          text: 'metric ton',
          key: 'METRIC_TON',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            wasteCategory: {
              type: 'string',
              enum: [
                'DISCARDED_TEXTILES',
                'GLASS',
                'METALS',
                'ORGANIC_WASTE',
                'PAINTS_&_SOLVENTS',
                'PAPER_&_CARDBOARD',
                'PCBS_&_PCTS',
                'PLASTICS',
                'RUBBER_WASTE',
                'UNKNOWN',
                'WASTE_OILS',
                'WOOD_WASTE',
              ],
            },
            disposalMethod: {
              type: 'string',
              enum: [
                'COMPOSTING_GARBAGE',
                'INCINERATE,_BURN_OR_DISPOSE_ON-SITE_(UNCERTIFIED)',
                'MUNICIPAL_GARBAGE_COLLECTION',
                'ON-SITE_DISPOSAL_(THIRD-PARTY_REVIEWED_OR_AUDITED)',
                'PRIVATE_THIRD-PART_RESPONSIBLE_DISPOSAL_(CERTIFIED)',
                'THIRD-PARTY_GARBAGE_COLLECTION_(UNCERTIFIED)',
                'UNKNOWN',
                "WASTE_IS_SEPARATED_AND_RECYCLED_OR_REUSED_FOR_ORGANIZATION'S_OWN_PRODUCTION_OR_DONATED/PROVIDED_TO_OTHER_FACILITIES",
              ],
            },
            unit: {
              type: 'string',
              enum: ['KILOGRAM', 'METRIC_TON'],
            },
            totalAnnualVolume: {
              type: 'number',
            },
            year: {
              type: 'number',
              minimum: 1000,
              maximum: 9000,
            },
          },
          required: ['wasteCategory', 'disposalMethod', 'unit', 'totalAnnualVolume', 'year'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 570,
  sectionId: '2.1.2.2',
  impactArea: 'Waste Streams',
  impactAreaId: 'WASTE_STREAMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
